import axios from '../../plugins/axios'

export const login = ({ commit }, user) => {
  if (user.email && user.password) {
    return axios.post('/api/login', user)
      .then((response) => {
          const user = response.data
          commit('SET_USER', { user })
          return response
        },
        (error) => {
          console.error(error)
        }
      )
  }
}

export const logout = ({ commit }) => {
  commit('SET_USER', { user: null })
}

export const sendRecoverPasswordEmail = ({ commit }, { email }) => {
  if (email && email !== '') {
    return axios.post('/api/auth/recover_password_email', { email })
      .catch((error) => {
        console.error(error)
      })
  }
}

export const changeUserPassword = ({}, { password, token }) => {
  if (password && password !== '') {
    const header = { headers: { Authorization: `bearer ${token}` } }
    return axios.put('/api/auth/change_password', { password }, header)
      .catch((error) => {
        console.error(error)
      })
  }
}

export const getGoogleOAuthUrl = ({ commit }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.get('/api/auth/google-cloud-auth-url', config)
    .then((res) => {
        const googleOAuthUrl = res.data.authUrl
        commit('SET_GOOGLE_OAUTH_URL', { googleOAuthUrl })
        return res
      },
      (err) => {
        commit('SET_GOOGLE_OAUTH_URL', { googleOAuthUrl: '' })
        console.error(err)
        return err.response
      }
    )
}

export const linkGoogleAccount = ({}, { data }) => {
  const token = JSON.parse(localStorage.getItem('user')).token
  const config = { headers: { Authorization: `Bearer ${token}` } }
  return axios.post('/api/auth/google-cloud', data, config)
    .then((res) => res)
    .catch((err) => err.response)
}
